export const CARD_ALIAS_TRANSLATION_ID = 'cardAlias.th';
